import { twMerge } from 'tailwind-merge';

import { Text } from '@/components/text';

import type { MessageBoxProps } from './alert.types';

const MessageBox = ({ icon, header, children, className }: MessageBoxProps) => {
  return (
    <div
      className={twMerge(
        'rounded-rad-a bg-white p-d shadow max-md:py-c md:p-b',
        className ? className : ''
      )}
    >
      <div className="mb-a flex items-center">
        {icon}
        <Text variant="h4">{header}</Text>
      </div>
      <Text variant="body2">{children}</Text>
    </div>
  );
};

export default MessageBox;
